import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid } from '@ltvco/refresh-lib/theme';
import { ArrowForward } from '@mui/icons-material';
import { AppConfig } from '@ltvco/refresh-lib/ctx';
import FrontScratchesIllustration from 'images/damage-analyzer/front-scratches.svg';
import {
  StyledCard,
  Headline,
  BodyText,
  AnalyzeButton,
  IllustrationGrid,
  IllustrationImage,
} from './constants';

export const DamageAnalyzerCTA = () => {
  const navigate = useNavigate();
  const { trackEventGA4 } = useContext(AppConfig);

  const handleAnalyzeDamageClick = () => {
    trackEventGA4({
      event_name: 'cta_click',
      type: 'view damage analyzer',
    });
    navigate('/bumper-chat/chat/photo-damage-analyzer');
  };

  return (
    <StyledCard id="damage-analyzer-cta" variant="outlined">
      <Grid container>
        {/* Text content */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={{ p: 3.5 }}>
            <Headline variant="h5">Analyze Vehicle Damage with AI</Headline>
            <BodyText variant="body1">
              Upload photos of damage to get an estimated repair cost, severity,
              and whether fixing it makes sense for this vehicle.
            </BodyText>
            <AnalyzeButton
              variant="contained"
              onClick={handleAnalyzeDamageClick}
              endIcon={<ArrowForward />}
            >
              Analyze Damage
            </AnalyzeButton>
          </Box>
        </Grid>

        {/* Illustration (Figma export) */}
        <IllustrationGrid size={{ xs: 12, md: 6 }}>
          <IllustrationImage
            src={FrontScratchesIllustration}
            alt="Damage analyzer preview showing a sample analysis result"
          />
        </IllustrationGrid>
      </Grid>
    </StyledCard>
  );
};
